import { jsx } from "react/jsx-runtime";
import PestControlRodentIcon from "@mui/icons-material/PestControlRodent";
import { validateTidalLicense } from "../../base/index.js";
function PestControlRodent(props) {
  return /* @__PURE__ */ jsx(
    PestControlRodentIcon,
    {
      "data-testid": "PestControlRodent",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PestControlRodent",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
PestControlRodent.tidalIconMeta = {
  categories: "miscellaneous",
  name: "PestControlRodent"
};
validateTidalLicense();
export {
  PestControlRodent
};
//# sourceMappingURL=PestControlRodent.js.map
